import { Link, LinkProps } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
type AppLink = {
  to: string;
} & LinkProps;
export const AppLink = ({
  to,
  children,
  ...props
}: AppLink) => {
  return <Link component={RouterLink} to={to} underline="none" {...props} data-sentry-element="Link" data-sentry-component="AppLink" data-sentry-source-file="AppLink.tsx">
      {children}
    </Link>;
};